import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await resetPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Could not send reset email');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left side - form */}
      <div className="flex-1 flex items-center justify-center bg-white px-6 py-12 lg:py-0 lg:w-1/2">
        <div className="w-full max-w-[400px]">
          <div className="text-center mb-6">
            <img src="/cscore-logo.png" alt="CScore" className="h-10 mx-auto" style={{ filter: 'brightness(0) saturate(100%) invert(13%) sepia(90%) saturate(5500%) hue-rotate(270deg) brightness(80%) contrast(110%)' }} />
          </div>

          {sent ? (
            <div className="text-center">
              <h2 className="text-[28px] font-semibold text-text mb-4">Check Your Email</h2>
              <p className="text-sm text-gray-600 mb-6">
                If an account exists for <strong>{email}</strong>, a password reset link has been sent.
              </p>
              <Link to="/login" className="text-primary font-medium text-sm hover:underline">
                Back to Sign In
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-[28px] font-semibold text-text text-center mb-2">Reset Password</h2>
              <p className="text-sm text-gray-600 text-center mb-8">
                Enter your email and we'll send you a link to reset your password.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-text mb-1.5">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full border border-[#E6E6E6] rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-30 focus:border-primary-30"
                  />
                </div>

                {error && (
                  <div className="mb-4 p-3 bg-destructive-10 border border-destructive-30 rounded-lg text-sm text-destructive">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 rounded-lg text-white font-semibold text-sm transition-colors disabled:opacity-50"
                  style={{ backgroundColor: '#CB9EF6' }}
                  onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = '#B279F0')}
                  onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = '#CB9EF6')}
                >
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>

                <p className="text-sm text-gray-600 mt-4 text-center">
                  Remember your password?{' '}
                  <Link to="/login" className="text-primary font-medium hover:underline">Sign In</Link>
                </p>
              </form>
            </>
          )}
        </div>
      </div>

      {/* Right side - gradient (hidden on mobile) */}
      <div
        className="hidden lg:flex lg:w-1/2 flex-col items-center justify-center px-12"
        style={{ background: 'radial-gradient(ellipse farthest-corner at 10% 10%, #7F31DB, #E1C2FA)' }}
      >
        <h2 className="text-white text-4xl font-bold mb-4 text-center">Measure What Matters</h2>
        <p className="text-white/80 text-lg text-center max-w-md leading-relaxed">
          Track clinician performance, improve patient outcomes, and make data-driven decisions for your treatment center.
        </p>
      </div>
    </div>
  );
}
